import {Employer} from './model.employer';
import { Consultation } from './consultation';
//import { TypeExamenSuplementaire } from "./typexamentSuplemantaire";

export class ExamenSuplementaire {
    examen_date_envoie:Date;
    id_consultataion:String;
    examen_renseignement:String;
    examen_lieu_etablisment:String; 

    examen_description:String;

    consultation:Consultation; 
    employer:Employer; 
  //  TypeExamenSuplementaire :TypeExamenSuplementaire = new TypeExamenSuplementaire();
    
    constructor(){
      
    }
}
